export const TestID = 'ChatInputFormSubmitButton.TestID';
